import React from 'react'
import '@loyal_template/placeholder.css'
const MileagePlaceholder = () => (
  <div className='container-fluid'>
    <div className='container py-5'>
      <div className='row'>
        <div className='col-8 pr-2 '>
          <div className='row mx-0'>
            <div className='col-12 radius border border-color-ui-3'>
              <div className='row'>
                <div className='col-12'>
                  <div className='bg-ui-4 py-5 radius-top row align-items-center px-1'>
                    <div className='col-12 px-2 py-2'>
                      <div className='row mx-0 shimmer'>
                        <div className='col-6 py-half bg-ui-3 radius' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row radius-bottom bg-white px-1'>
                <div className='col-12 px-2 py-2'>
                  <div className='row mx-0'>
                    <div className='col-10 py-half bg-ui-4 radius' />
                  </div>
                </div>
                <div className='col-12 px-3 pb-3'>
                  <div className='row'>
                    <div className='col-12 px-0'>
                      <div className='row mx-0'>
                        <div className='col-6 mr-0'>
                          <div className='row mr-0'>
                            <div className='col-12 pt-2 pb-3 border-ui-4 radius' />
                          </div>
                        </div>
                        <div className='col-6 ml-0'>
                          <div className='row ml-0'>
                            <div className='col-12 pt-2 pb-3 border-ui-4 radius' />
                          </div>
                        </div>
                        <div className='col-6 mr-0'>
                          <div className='row mr-0'>
                            <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                          </div>
                        </div>
                        <div className='col-6 ml-0'>
                          <div className='row ml-0'>
                            <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-12 px-3 pb-3'>
                  <div className='row'>
                    <div className='col-12 px-0'>
                      <div className='row mx-0'>
                        <div className='col-auto mr-0'>
                          <div className='row mr-0'>
                            <div className='col-1 py-1 border-ui-4 radius' />
                          </div>
                        </div>
                        <div className='col-6 mr-0'>
                          <div className='row mr-0'>
                            <div className='col-8 py-1 bg-ui-4 radius' />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-12 px-3 pb-3'>
                  <div className='row'>
                    <div className='col-12 px-0'>
                      <div className='row mx-0'>
                        <div className='col-auto mr-0'>
                          <div className='row mr-0'>
                            <div className='col-1 py-1 border-ui-4 radius' />
                          </div>
                        </div>
                        <div className='col-6 mr-0'>
                          <div className='row mr-0'>
                            <div className='col-6 py-1 bg-ui-4 radius' />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='cart-side col-4 border-ui-3 radius bg-white px-0 py-0'>
          <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
            <div className='row mx-0 py-1 shimmer'>
              <div className='col-9 py-half bg-ui-3 radius' />
            </div>
          </div>
          <div className='cart-subtotal col-12 pb-3 mx-0'>
            <div className='row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'>
              <div className='col-9  txt-left  justify-content-center align-self-center'>
                <div className='row mx-0'>
                  <div className='col-6 py-half bg-ui-4 radius' />
                </div>
                <div className='row mx-0 mt-1'>
                  <div className='col-6 py-half bg-ui-4 radius' />
                </div>
                <div className='row mx-0 mt-1'>
                  <div className='col-7 py-half bg-ui-4 radius' />
                </div>
                <div className='row mx-0 mt-1'>
                  <div className='col-9 py-half bg-ui-4 radius' />
                </div>
              </div>
            </div>
            <div className='row product-brand pt-3  px-2'>
              <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
                <div className='row mx-0'>
                  <div className='col-12 py-half bg-ui-4 radius' />
                </div>
                <div className='row mx-0 mt-1'>
                  <div className='col-12 py-half bg-ui-4 radius' />
                </div>
                <div className='row mx-0 mt-1'>
                  <div className='col-12 py-half bg-ui-white radius' />
                </div>
                <div className='row mx-0 mt-1'>
                  <div className='col-7 py-half bg-ui-4 radius' />
                </div>
              </div>
            </div>

            <div className='cart-done row  px-2 pt-2 '>
              <div className='col-12 justify-content-center align-self-center'>
                <div className='row mx-0 mt-1 shimmer'>
                  <div className='col-12 pt-3 pb-4 bg-ui-3 radius' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default MileagePlaceholder



// WEBPACK FOOTER //
// ./src/features/MileageRescue/MileagePlaceholder.js